import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"

interface SendRegretDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    vacancyTitle?: string
    hiredCandidateName?: string
    isSending?: boolean
}

export function SendRegretDialog({
    open,
    onOpenChange,
    onConfirm,
    vacancyTitle,
    hiredCandidateName,
    isSending = false,
}: SendRegretDialogProps) {
    const closeDialog = () => onOpenChange(false)

    const handleConfirm = () => {
        closeDialog()
        onConfirm()
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px] bg-card">
                <DialogHeader>
                    <DialogTitle>Send regret emails?</DialogTitle>
                    <DialogDescription className="text-muted-foreground mt-2">
                        {hiredCandidateName && (
                            <span className="block mb-2">
                                You have hired <span className="font-semibold text-foreground">{hiredCandidateName}</span>
                                {vacancyTitle && ` for "${vacancyTitle}"`}.
                            </span>
                        )}
                        Do you want to notify other candidates who were not selected?
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter className="mt-4 gap-2">
                    <Button
                        variant="outline"
                        onClick={closeDialog}
                        disabled={isSending}
                    >
                        Don't Send
                    </Button>

                    <Button
                        onClick={handleConfirm}
                        disabled={isSending}
                    >
                        {isSending ? "Sending..." : "Send"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
